import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../Auth/AuthContext";
import { LoadingState } from "../Components/Common/WorkspaceState";

const PrivateRoute = () => {
  const { user, initializing, sessionExpired } = useAuth();
  const location = useLocation();
  if (initializing) return <main className="container py-5"><LoadingState label="Verifying your session" /></main>;
  return user ? <Outlet /> : <Navigate to="/login" replace state={{ from: location, sessionExpired }} />;
};

export default PrivateRoute;
